import { Navigation as NavigationSwiper } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useState } from 'react'
import { Spinner } from 'react-bootstrap'
import Imgix from 'react-imgix'
import { useTranslation } from 'react-i18next'
import { PostImage, PostStatus } from '../../app/models/Post'
import { favoriteBtn } from '../../app/models/Favorite'
import { useStore } from '../../app/stores/store'
import { history } from '../..'
import { AuctionPublic, FilterModes } from '../../app/models/modes'
import { AuctionStatus } from '../../app/models/Auction'
import { observer } from 'mobx-react-lite'

interface Props {
  postImages: PostImage[]
  details?: boolean
  round?: number
  totalRounds?: number
  favButtons?: favoriteBtn[]
  loadingFavBtn?: boolean
  width?: number
  id: string
  slug: string
  favorites?: boolean
  type?: FilterModes
  auctionPublic?: AuctionPublic
  auctionStatus?: AuctionStatus
  postStatus?: PostStatus
}

function PostImagesSwiper({
  postImages,
  details = false,
  round,
  totalRounds,
  favButtons,
  loadingFavBtn,
  width = 1920,
  id,
  slug,
  favorites = false,
  type,
  auctionPublic,
  auctionStatus,
  postStatus,
}: Props) {
  const { favoriteAuctionsStore, logsStore } = useStore()
  const { loadingFavorites } = favoriteAuctionsStore
  const [imageIndex, setImageIndex] = useState(1)
  const { t } = useTranslation()
  postImages = postImages?.slice().sort((a: any, b: any) => b.primary - a.primary) ?? []

  const formatImage = (image: string) => {
    const imageArr = image.split('upload/')
    const formatedImage = `${imageArr[0]}upload/c_scale,w_${width}/${imageArr[1]}`
    return formatedImage
  }

  const handleClick = () => {
    if (type === FilterModes.post) {
      history.push(`/posts/${slug}`)
    } else if (type === FilterModes.auction) {
      history.push(`/auctions/${slug}`)
    }
  }

  return (
    <>
      <Swiper
        navigation
        modules={[NavigationSwiper]}
        className='mySwiper'
        style={{ height: '100%' }}
        onSlideChange={(swiper) => setImageIndex(swiper.activeIndex + 1)}
      >
        {postImages?.map((images, index) => (
          <SwiperSlide
            onClick={handleClick}
            key={index}
            className={`auction-card-header-img ${
              favorites && postImages.length === 1 ? 'swiper-max-content' : ''
            }`}
          >
            <Imgix
              className='lazyload'
              src={formatImage(images.image)}
              sizes='auto'
              attributeConfig={{
                src: 'data-src',
                srcSet: 'data-srcset',
                sizes: 'data-sizes',
              }}
              htmlAttributes={
                <div className='d-flex justify-content-center h-100 align-items-center'>
                  <Spinner variant='primary' />
                </div>
              }
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {!auctionPublic && logsStore.isPostNew(id) && (
        <span className='auction-type-new'>{t('new')}</span>
      )}
      {auctionPublic === AuctionPublic.Private && (
        <span className='auction-type-new auction-type-private'>{t('private')}</span>
      )}
      {(auctionStatus === AuctionStatus.Deleted || postStatus === PostStatus.Deleted) && (
        <span className='auction-type-new auction-type-deleted'>{t('archived')}</span>
      )}
      {round && (
        <span className='auction-type-round'>
          {t('round')}:{' '}
          {t('round_details', {
            round: round,
            totalRounds: totalRounds,
          })}
        </span>
      )}
      {details &&
        (loadingFavorites || loadingFavBtn ? (
          <span className='auction-type-heart'>
            <Spinner size='sm' animation='border' variant='dark' />
          </span>
        ) : (
          favButtons?.map(
            (btn, index) =>
              btn.show && (
                <span className='auction-type-heart' key={index} onClick={btn.onClick}>
                  <i className={btn.icon} />
                </span>
              ),
          )
        ))}
      {postImages!.length > 1 && (
        <span className='auction-image-span'>
          {imageIndex}/{postImages?.length}
        </span>
      )}
    </>
  )
}
export default observer(PostImagesSwiper)
